import { toast } from 'react-toastify';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
  AddHobbiesFailure,
  AddHobbiesSuccess,
  EditHobbiesFailure,
  EditHobbiesSuccess,
} from '../../Redux/Actions/HobbiesAction';
import { ADD_HOBBIES, EDIT_HOBBIES } from '../../Redux/Actiontype';
import routeRules from '../../Routes/routeRules';
import history from '../../Store/history';
import { Basepath } from '../../config';

const clearSession = msg => {
  localStorage.clear();
  alert(msg);
  window.location = '/';
};
export const AddHobbiesEpic = action$ =>
  action$.pipe(
    ofType(ADD_HOBBIES),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/addHobbies`, action.payload, { authentication: localStorage.getItem('sessionId') })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              history.push(routeRules.hobbiesmanagement, toast.success(response.response.message));
              return of(AddHobbiesSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              console.log(response.response);
              return of(AddHobbiesFailure(response.response));
            }
          }),
        ),
    ),
  );
export const EditHobbiesEpic = action$ =>
  action$.pipe(
    ofType(EDIT_HOBBIES),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/editHobbies`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(EditHobbiesSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(EditHobbiesFailure(response.response));
            }
          }),
        ),
    ),
  );
